module.exports = Promise.all([__parcel__import__("lbK6x"), __parcel__import__("4fnPF")]).then(() => parcelRequire('g36Vt'));